
import Uploader from '@/components/Uploader/index.vue';

export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },

  components: {
    Uploader: Uploader
  }
};